module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_04.2583b903.png";